import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://fuoejykgpnfphrvqjuub.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ1b2VqeWtncG5mcGhydnFqdXViIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY2MDUwOTcsImV4cCI6MjA5MjE4MTA5N30.-Iea55F7GszWyCny9Br94t6A9vpD8oCyQPfyw1gE8fw'

// Explicit auth config to maximize "stay logged in forever" behavior on
// iPhone / iPad / desktop. Without these the JWT silently expires after
// an hour and iOS Safari aggressively evicts localStorage on idle —
// so staff would constantly be re-logging-in.
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,        // keep session across reloads/closes
    autoRefreshToken: true,      // silently swap expired JWTs for new ones
    detectSessionInUrl: true,    // pick up auth tokens from URL after email/OAuth
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'elyon-auth',    // explicit key so we can reason about it
    flowType: 'pkce',            // safer + more reliable than the old implicit flow
  },
});

// Belt-and-suspenders: whenever the tab becomes visible again, force a
// refresh of the session. Solves the iOS case where the OS suspended JS
// for hours, the auto-refresh timer didn't fire, and the JWT is now stale.
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      supabase.auth.getSession().then(({ data }) => {
        // If we have a session but it's expired, force a refresh
        const exp = data?.session?.expires_at;
        if (exp && exp * 1000 < Date.now()) {
          supabase.auth.refreshSession();
        }
      });
    }
  });
}
